"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var getDesktopCDNLink = function getDesktopCDNLink(url, appEnvUrl) {
  var _domainMap$appEnv;
  var appEnv = process.env.NEXT_PUBLIC_APP_ENV;
  var defaultDomain = appEnvUrl !== null && appEnvUrl !== void 0 ? appEnvUrl : 'production';

  // to-do: remove comment.

  var domainMap = {
    development: 'https://cdn-dev.lumirental.com',
    staging: 'https://cdn-staging.lumirental.com',
    production: 'https://cdn.lumirental.com'
  };
  var prefix = '/desktop';
  var finalDomain = (_domainMap$appEnv = domainMap[appEnv]) !== null && _domainMap$appEnv !== void 0 ? _domainMap$appEnv : domainMap[defaultDomain];
  var fullUrl = finalDomain + prefix;
  return fullUrl + url;
};
var _default = exports["default"] = getDesktopCDNLink;